import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useColorMode } from 'contexts/ColorModeContext';

/**
 * The light/dark switch on the signed-out screens.
 *
 * Inside the dashboard this control lives in the account cluster, next to the
 * avatar — but there is no account cluster before you have signed in, and the
 * sign-in screen is the one page a dark-mode user is guaranteed to see first.
 * Hence a floating button, here only.
 *
 * It used to toggle a `dark` class on the document and nothing read it, so
 * the button did nothing at all. It drives the real preference now, and what
 * you pick here is still set after you sign in.
 */
export default function FixedPlugin(props) {
  const { mode, toggle } = useColorMode();
  const dark = mode === 'dark';

  return (
    <Tooltip title={dark ? 'Switch to light' : 'Switch to dark'}>
      <Fab
        onClick={toggle}
        aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
        sx={{
          position: 'fixed',
          right: '35px',
          bottom: '30px',
          background: 'linear-gradient(to bottom, #7551FF, #422AFB)',
          color: '#fff',
          '&:hover': { background: 'linear-gradient(to bottom, #4318FF, #2111D8)' },
        }}
        {...props}
      >
        {dark ? <LightModeIcon /> : <DarkModeIcon />}
      </Fab>
    </Tooltip>
  );
}
